import React from 'react';
import { Menu, MenuProps, SxProps, Theme } from '@mui/material';

export interface ContextMenuPosition {
  mouseX: number;
  mouseY: number;
}

interface ContextMenuProps {
  position: ContextMenuPosition | null;
  onClose: MenuProps['onClose'];
  children: React.ReactNode;
  paperSx?: SxProps<Theme>;
  sx?: SxProps<Theme>;
}

const ContextMenu: React.FC<ContextMenuProps> = ({
  position,
  onClose,
  children,
  paperSx,
  sx,
}) => {
  return (
    <Menu
      open={position !== null}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={
        position !== null
          ? { top: position.mouseY, left: position.mouseX }
          : undefined
      }
      PaperProps={paperSx ? { sx: paperSx } : undefined}
      sx={sx}
    >
      {children}
    </Menu>
  );
};

export default ContextMenu;